export const $rankingSearchSettings = function() {
  var settings = {
    searchParams: {
      token: null,
      site: null,
      list_id: null,
      keywords: [],
      country: null
    },
    changed: false,
    source: 'ranking',
    setChanged: function(val) {
      this.changed = val;
    }
  };

  return settings;
};

$rankingSearchSettings.$inject = [];
